import { TargetStatus } from "@biggeo/bg-server-lib/studio";
import { ComputeStatus } from "@biggeo/bg-server-lib/studio";
import { Box, Button, CompanyAvatar, IconButton, LoadingBar, Menu, MenuItem, OverflowingTypography, Stack, Switch, Typography, } from "../components";
import { DeleteOutline, MoreVertOutline } from "../icons";
import { getRandomColor } from "@biggeo/bg-utils";
import React from "react";
export const DataSampleCard = ({ status, targetState, onBuyNowClick, onContactSalesClick, onSwitchClick, onDeleteClick, isBuyNowDisabled = false, color, image, name, organization, isSelected, fkDataSourceId, disabled = false, }) => {
    const isLoading = status === ComputeStatus.loading;
    const isHot = status === ComputeStatus.hot && targetState === TargetStatus.hot;
    return (React.createElement(Stack, null,
        isLoading && (React.createElement(LoadingBar, { color: "primary", sx: {
                borderTopLeftRadius: (theme) => theme.radius.xs5,
                borderTopRightRadius: (theme) => theme.radius.xs5,
                height: 2,
            } })),
        React.createElement(Stack, { width: "100%", height: "100%", sx: {
                border: 1,
                borderColor: (theme) => theme.palette.stroke[100],
                borderTopLeftRadius: (theme) => theme.radius.xs5,
                borderTopRightRadius: (theme) => theme.radius.xs5,
            } },
            React.createElement(Box, { sx: {
                    borderTopLeftRadius: "inherit",
                    borderTopRightRadius: "inherit",
                    height: 2,
                    width: "100%",
                    background: isLoading
                        ? undefined
                        : `linear-gradient(90deg, #EBEFFE 0%, ${color !== null && color !== void 0 ? color : getRandomColor()} 100%)`,
                } }),
            React.createElement(Stack, { width: "100%", gap: 2, sx: {
                    paddingX: isLoading ? 2 : undefined,
                    padding: isLoading ? undefined : 2,
                    paddingBottom: isLoading ? 2 : undefined,
                } },
                React.createElement(Stack, { width: "100%", flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Stack, { width: "100%", flexDirection: "row", gap: 2, alignItems: "center" },
                        React.createElement(Box, { sx: {
                                padding: 1,
                                backgroundColor: (theme) => theme.palette.surface.container,
                                borderRadius: (theme) => theme.radius.default,
                            } },
                            React.createElement(CompanyAvatar, { size: "sm", src: image, square: true })),
                        React.createElement(Stack, null,
                            React.createElement(OverflowingTypography, { variant: "body3", fontWeight: "semibold", sx: {
                                    maxWidth: (theme) => theme.spacing(41),
                                } }, name),
                            organization && (React.createElement(OverflowingTypography, { variant: "body4", textColor: "disabled.onContainer" }, `By ${organization}`)))),
                    onDeleteClick && (React.createElement(Menu, { placement: "bottom-end", content: React.createElement(MenuItem, { startNode: React.createElement(DeleteOutline, { color: "error" }), label: "Delete Sample", color: "error", density: "dense", onClick: onDeleteClick }) },
                        React.createElement(IconButton, { variant: "minimal" },
                            React.createElement(MoreVertOutline, null))))),
                React.createElement(Stack, { flexDirection: "row", justifyContent: "space-between", alignItems: "center" },
                    React.createElement(Typography, { variant: "body3", textColor: "disabled.onContainer" }, "View Sample"),
                    React.createElement(Switch, { switched: isSelected, disabled: !isHot || disabled, onSwitchChange: () => {
                            onSwitchClick({
                                dataSourceId: fkDataSourceId,
                                isSelected: !isSelected,
                            });
                        } })),
                React.createElement(Stack, { flexDirection: "row", gap: 4 },
                    React.createElement(Button, { color: "primary", onClick: () => {
                            onBuyNowClick();
                        }, disabled: isBuyNowDisabled }, "Buy Now"),
                    onContactSalesClick && (React.createElement(Button, { variant: "minimal", onClick: () => {
                            onContactSalesClick();
                        } }, "Contact Sales")))))));
};
//# sourceMappingURL=DataSampleCard.js.map